import { Component, OnInit, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { NexusComponent } from '../nexus/nexus.component';
import * as moment from 'moment';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'nexus-form-date-input',
    templateUrl: './nexus-form-date-input.component.html',
    styleUrls: ['./nexus-form-date-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => NexusFormDateInputComponent),
        }
    ],
    standalone: false
})
export class NexusFormDateInputComponent extends NexusComponent implements ControlValueAccessor, OnInit {

  @Input() public label = 'Date';
  public is_disabled = false;
  public display_value: string = null;
  public has_invalid_date = false;

  @Output() invalidDateChange = new EventEmitter<boolean>();

  constructor() {
    super();
  }

  ngOnInit() { }

  private propagateChange = (_value: any) => { };

  handleChange() {
    const was_invalid = this.has_invalid_date;

    if (this.display_value && this.display_value.length === 10) {
      const parts = this.display_value.split('/');
      const month = parseInt(parts[0], 10);
      const day = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      const rangeValid = month >= 1 && month <= 12 &&
                         day >= 1 && day <= 31 &&
                         year >= 1900 && year <= 2100;
      const date = rangeValid ? moment.utc(this.display_value, 'MM/DD/YYYY', true) : null;
      if (date && date.isValid()) {
        this.has_invalid_date = false;
        this.propagateChange(date.toDate());
      } else {
        this.has_invalid_date = true;
        this.propagateChange(null);
      }
    } else {
      this.has_invalid_date = false;
      this.propagateChange(null);
    }

    if (was_invalid !== this.has_invalid_date) {
      this.invalidDateChange.emit(this.has_invalid_date);
    }
  }

  writeValue(obj: any): void {
    if (obj) {
      const m = moment(obj);
      this.display_value = m.isValid() ? m.format('MM/DD/YYYY') : null;
    } else {
      this.display_value = null;
    }
    this.has_invalid_date = false;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void { }

  setDisabledState(isDisabled: boolean): void {
    this.is_disabled = isDisabled;
  }

}
